import { VueEditor } from 'vue2-editor'
import 'vue-select/dist/vue-select.css'
import Vue from 'vue'

Vue.component('vue-editor', VueEditor)
